import type { IconName } from '@/components/common/Icon';

export const MODULE_KEY = {
  calendar: 'calendar',
  clients: 'clients',
  patients: 'patients',
  settings: 'settings',
  branding: 'branding',
  treatmentLibrary: 'treatment_library',
  sessionNotes: 'session_notes',
  firstConsultation: 'first_consultation',
  treatmentPlans: 'treatment_plans',
  files: 'files',
  consents: 'consents',
  communications: 'communications',
  services: 'services',
  reports: 'reports',
  calendarSync: 'calendar_sync',
  chat: 'chat',
  broadcasts: 'broadcasts',
  customDomains: 'custom_domains',
  aiAssistant: 'ai_assistant',
  voiceAssistant: 'voice_assistant',
} as const;

export type ModuleKey = (typeof MODULE_KEY)[keyof typeof MODULE_KEY];

export interface ModuleCatalogEntry {
  key: ModuleKey;
  iconName: IconName;
  isCore: boolean;
  isComingSoon: boolean;
}

export const MODULE_CATALOG: ModuleCatalogEntry[] = [
  { key: MODULE_KEY.calendar, iconName: 'Calendar', isCore: true, isComingSoon: false },
  { key: MODULE_KEY.clients, iconName: 'Users', isCore: true, isComingSoon: false },
  { key: MODULE_KEY.patients, iconName: 'PawPrint', isCore: true, isComingSoon: false },
  { key: MODULE_KEY.settings, iconName: 'Settings', isCore: true, isComingSoon: false },
  { key: MODULE_KEY.branding, iconName: 'Palette', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.treatmentLibrary, iconName: 'BookOpen', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.sessionNotes, iconName: 'FilePlus', isCore: false, isComingSoon: false },
  {
    key: MODULE_KEY.firstConsultation,
    iconName: 'ClipboardCheck',
    isCore: false,
    isComingSoon: false,
  },
  { key: MODULE_KEY.treatmentPlans, iconName: 'Clipboard', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.files, iconName: 'Folder', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.consents, iconName: 'ShieldCheck', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.communications, iconName: 'MailCheck', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.services, iconName: 'Tag', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.reports, iconName: 'BarChart', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.calendarSync, iconName: 'RefreshCw', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.chat, iconName: 'MessageCircle', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.broadcasts, iconName: 'Megaphone', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.customDomains, iconName: 'Globe', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.aiAssistant, iconName: 'Sparkles', isCore: false, isComingSoon: false },
  { key: MODULE_KEY.voiceAssistant, iconName: 'Mic', isCore: false, isComingSoon: false },
];

export const LOGO_VARIANT = {
  full: 'full',
  tablet: 'tablet',
  mobile: 'mobile',
  icon: 'icon',
} as const;

export type LogoVariant = (typeof LOGO_VARIANT)[keyof typeof LOGO_VARIANT];

export const LOGO_VARIANTS: LogoVariant[] = [
  LOGO_VARIANT.full,
  LOGO_VARIANT.tablet,
  LOGO_VARIANT.mobile,
  LOGO_VARIANT.icon,
];
